import styled from "styled-components";
import { PageSectionHeading } from "../../../../../../CommonComponents/commonStyles";

export const FlexContainer = styled.div`
display: flex;
align-items: center;
margin-bottom: 20px;
@media only screen and (max-width: 767px) {
  justify-content: space-between;
}
`;

export const PageHeading = styled(PageSectionHeading)`
    padding-right: 12px;
`

export const GridDiv = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  letter-spacing: normal;
  text-transform: capitalize;
`;